// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Alert, Tooltip, Typography } from '@mui/material';

const extraItemsTooltipTitle =
  'Note: This shipment contains items that were not on the fulfillment order';

/**
 * Shows the standard extra-items warning used for shipments with items that
 * were not part of the fulfillment order.
 */
export function ExtraItemsAlert() {
  return (
    <Tooltip arrow title={extraItemsTooltipTitle}>
      <Alert
        severity="warning"
        sx={{
          alignItems: 'center',
          py: 0,
          px: 1.25,
          '& .MuiAlert-icon': {
            marginRight: 0.5,
            fontSize: 18,
          },
          '& .MuiAlert-message': {
            py: 0,
          },
        }}
      >
        <Typography variant="caption" fontWeight="bold">
          Extra items
        </Typography>
      </Alert>
    </Tooltip>
  );
}
